import React from 'react';
import { useQuery } from '@apollo/client';

// Material UI
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';

// Components
import { SectionHeading } from '../../_core/_ui/typography.component';
import { SectionWrapper } from '../../_core/_ui/structure.components';
import { CheckInGraphQL, GET_CHECK_IN } from '../../Session/CheckIn/check-in.graphql';
import { CreatePlayerData } from '../../Player/CreatePlayer/create-player.graphql';
import FullPageLayout from '../_layout/FullPageLayout/full-page.layout';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';
import { ROLES } from '../../../../_configuration';

// Check-in staff register walk-up players here, and only here. See "The check-in role writes only what the check-in page does" in CLAUDE.md.
const CHECK_IN_PLAYER_ROLES = [ROLES.CHECK_IN, ROLES.CONFIGURATION];

interface ICheckInPage {
  match: any;
}

const CheckInPage: React.FC<ICheckInPage> = ({ match }) => {
  const { assessmentSessionId } = match.params;
  const termLookup = useCompanySportTerminology()
  // Same query and variables as CheckInGraphQL, so Apollo sends one request for both.
  const { data } = useQuery(GET_CHECK_IN, { variables: { assessmentSessionId } });
  const sessionAgeGroup: IAgeGroup | undefined = data?.assessmentSession?.ageGroup;

  return (
    <FullPageLayout>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CheckInGraphQL assessmentSessionId={assessmentSessionId} />
        </Grid>
        <Box my={2}><Divider /></Box>
        {sessionAgeGroup && (
          <Grid item xs={12} md={6}>
            <Paper>
              <Box p={2}>
                <SectionHeading>Create a New {termLookup[SportTerminology.ATHLETE]}</SectionHeading>
                <SectionWrapper>
                  <CreatePlayerData ageGroupRoles={CHECK_IN_PLAYER_ROLES} ageGroup={sessionAgeGroup} />
                </SectionWrapper>
              </Box>
            </Paper>
          </Grid>
        )}
      </Grid>
    </FullPageLayout>
  );
};

export default CheckInPage;
